module.exports = __webpack_public_path__ + "img/60_9.534e4ac7.png";